import axios from "axios";
import $store from "../store";

const defaultOpt = { login: true };

function baseRequest(options) {
  return new Promise((resolve, reject) => {
    axios({
      method: options.method, // `method` 是创建请求时使用的方法
      baseURL: $store.state.sysApi+"/",  // 它可以通过设置一个 `baseURL` 便于为 axios 实例的方法传递相对 URL
      url: options.url,  // `url` 是用于请求的服务器 URL
      data: options.data
    }).then(res => {
      if (res.code === 200) {
        return resolve(res);
      } else {
        return reject({ msg: res.message, res});
      }
    })
  }).catch((res) => {
    //let errorResult = verifyErrorResult(res.response.data.code);
    //console.log(errorResult);
  })
}

/**
 * http 请求基础类
 * 参考文档 https://www.kancloud.cn/yunye/axios/234845
 *
 */
const request = ["post", "put", "patch"].reduce((request, method) => {
  /**
   *
   * @param url string 接口地址
   * @param data object get参数
   * @param options object axios 配置项
   * @returns {AxiosPromise}
   */
  request[method] = (url, data = {}, options = {}) => {
    return baseRequest(
      Object.assign({ url, data, method }, defaultOpt, options)
    );
  };
  return request;
}, {});

["get", "delete", "head"].forEach(method => {
  /**
   *
   * @param url string 接口地址
   * @param params object get参数
   * @param options object axios 配置项
   * @returns {AxiosPromise}
   */
  request[method] = (url, params = {}, options = {}) => {
    return baseRequest(
      Object.assign({ url, params, method }, defaultOpt, options)
    );
  };
});

export default request;
